// extracted by mini-css-extract-plugin
export var measureBox = "_cf-0";